<component-modal>
  <ng-container title>
    {{ title() }}
  </ng-container>
  <ng-container body>
    <div class="preview-wrap">
      <img [src]="src()" alt="Preview" />
    </div>
  </ng-container>
  <ng-container footer>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close()">Close</button>
    <button type="button" class="btn btn-primary" (click)="download()">Download</button>
  </ng-container>
</component-modal>
